import React, {FC, useEffect, useState} from 'react'
import {Row, Col, InputGroup, Form} from 'react-bootstrap'
import {capitalizeWords} from 'thesis-and-dissertations/helpers/helper'
import Api from '../../../../../thesis-and-dissertations/helpers/api'

type Props = {
  handleInputFilter: any
  status: any
  statusName: string
}

const api = new Api()

const SearchFilterBarContent: FC<Props> = ({handleInputFilter, status, statusName}) => {
  const [formValue, setFormValue] = useState({})
  const [loading, setLoading] = useState(false)
  const [programBeasiswa, setProgramBeasiswa] = useState([])

  useEffect(() => {
    getProgramBeasiswa()
  }, [])

  useEffect(() => {
    handleInputFilter(formValue)
  }, [formValue])

  const handleInput = (name: string, e: any) => {
    setFormValue({...formValue, [name]: e.target.value})
  }

  const getProgramBeasiswa = (params = {}) => {
    setLoading(true)
    api
      .getProgramBeasesiwa({...params})
      .then((response: any) => {
        setLoading(false)
        const data = response.data.data
        setProgramBeasiswa(data?.items)
      })
      .catch((error: any) => {
        setLoading(false)
        const {data} = error.response
      })
  }

  return (
    <div className='p-7 rounded-4 bg-white'>
      <Row className='g-2'>
        {/* Search Input */}
        <Col md={6} sm={12}>
          <InputGroup>
            <InputGroup.Text className='bg-white border-end-0'>
              <i className='bi bi-search text-secondary'></i>
            </InputGroup.Text>

            <Form.Control
              type='text'
              placeholder='Cari nama alumni atau universitas...'
              className='rounded-end border-start-0'
              onChange={(e: any) => {
                handleInput('q', e)
              }}
            />

            <InputGroup.Text className='bg-white border-0' style={{cursor: 'pointer'}}>
              <i className='bi bi-funnel text-black'></i>
            </InputGroup.Text>
          </InputGroup>
        </Col>

        {/* Dropdown Status */}
        <Col md={3} sm={6}>
          <Form.Select
            onChange={(e: any) => {
              handleInput(statusName, e)
            }}
          >
            <option value=''>Semua Status</option>
            {status?.map((item: any, index: any) => (
              <option value={item} key={index}>
                {capitalizeWords(item)}
              </option>
            ))}
          </Form.Select>
        </Col>

        {/* Dropdown Program */}
        <Col md={3} sm={6}>
          <Form.Select
            onChange={(e: any) => {
              handleInput('program_beasiswa', e)
            }}
          >
            <option value=''>Semua Program</option>
            {programBeasiswa?.map((item: any, index: any) => (
              <option value={item.value} key={index}>
                {item?.label}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
    </div>
  )
}

const SearchFilterBar: FC<Props> = ({handleInputFilter, status, statusName}) => {
  return (
    <SearchFilterBarContent
      handleInputFilter={handleInputFilter}
      status={status}
      statusName={statusName}
    />
  )
}

export default SearchFilterBar
